import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface TaxListState {
    list: any,
  }
  
const initialState:TaxListState = {
    list:undefined,
}

export const TaxListSlice = createSlice({
    name:"taxList",
    initialState,
    reducers:{
        UpdateTaxList: (state,action) => {
            state.list = action.payload.taxList;
        },
        AddTax: (state,action) => {
            state.list = undefined;
        },
        EditTax: (state,action) => {
            state.list = undefined;
        },
        RemoveTax: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateTaxList,AddTax,EditTax,RemoveTax} = TaxListSlice.actions

export const selectTaxList = (state: RootState) => state.taxList

export default TaxListSlice.reducer;